import _ from 'lodash';

/**
 * @name AppointmentRouteController
 * @description Controller called to display/manage appointments and projects
 * @param {angular} $log The Angular $log service
 * @param {angular} $stateParams The Angular $log service
 * @param {service} GetAppointmentShop The GetAppointmentShop service
 * @param {service} MessageTemplates The MessageTemplates service
 */
function AppointmentRouteController(
  $log,
  $stateParams,
  GetAppointmentShop,
  MessageTemplates
) {
  let vm = this;
  vm.$onInit = function() {
    vm.updateProject = updateProject;
    vm.updateAppointment = updateAppointment;
    vm.uiOnParamsChanged = uiOnParamsChanged;
  };

  vm.currentAppointment = findCurrentAppointment($stateParams.appointment_id);

  /**
   * @name findCurrentAppointment
   * @description Function to find the current appointment based on the URL
   * param appointment_id
   * @param {number} currentAppointmentId The ID of the current appointment
   * @return {object} Returns the current appointment
   */
  function findCurrentAppointment(currentAppointmentId) {
    return _.find(vm.appointments, function(appointment) {
      if (appointment.id === Number(currentAppointmentId)) {
        return true;
      }
    });
  }

  /**
   * @name uiOnParamsChanged
   * @description A ui-router function callback when param values change
   * @param {object} newParams The name of the param that changed
   */
  function uiOnParamsChanged(newParams) {
    vm.currentAppointment = findCurrentAppointment(newParams.appointment_id);
  }

  /**
   * @name updateProject
   * @description Function to update the project object after it's changed
   * @param {object} project The project update
   */
  function updateProject(project) {
    vm.project = project;
  }

  /**
   * @name updateAppointment
   * @description Function to update the current appt object after it has change
   * @param {object} appointment The appointment update
   */
  function updateAppointment(appointment) {
    vm.currentAppointment = appointment;

    // Update the appointments array
    let newAppointment = [];
    newAppointment.push(appointment);
    vm.appointments = _.unionBy(newAppointment, vm.appointments,
    function(data) {
      return data.id;
    });
  }

  // Set the shop object data for each appointment
  GetAppointmentShop.get(vm.appointments).then(function(shops) {
    _.each(shops, function(shop) {
      MessageTemplates.get(shop.message_templates)
      .then(function(response) {
        shop.messageTemplates = response;
      });

      _.each(vm.appointments, function(appointment) {
        if (appointment.shop === shop.id) {
          appointment.shop = shop;
        }
      });
    });
  });

  $log.debug('Appointments from appointment route: ', vm.appointments);
  $log.debug('Project from appointment route: ', vm.project);
  $log.debug('Current appt from appointment route: ', vm.currentAppointment);
}

angular
  .module('inkfinder')
  .controller('AppointmentRouteController', AppointmentRouteController);



// WEBPACK FOOTER //
// ./routes/appointment/appointment-route.controller.js